<template>
  <div>
    <BaseTitle :title="$t(!editable ? 'content.view_quiz' : edit ? 'content.edit_quiz' : 'content.create_quiz')" :yearPeriode="titleData" />

    <!-- Quiz Information -->
    <v-card class="pa-6 mb-6">
      <v-row>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.quiz_title')" :validator="$v.quizTitle">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-model="quizTitle"
                v-bind="attrs"
                :disabled="!editable"
                :label="$t('content.quiz_title')"
                @input="$v.quizTitle.$touch()"
                @blur="$v.quizTitle.$touch()"
              />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.class_level')" :validator="$v.gradeId">
            <template slot-scope="{ attrs }">
              <v-select
                v-model="gradeId"
                v-bind="attrs"
                item-value="gradeId"
                item-text="gradeName"
                :disabled="!editable"
                :items="classLevel"
                :label="$t('content.class_level')"
                @change="getCourse"
              />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="2" class="py-0">
          <form-group :name="$t('menu.course')" :validator="$v.courseId">
            <template slot-scope="{ attrs }">
              <v-select
                v-model="courseId"
                v-bind="attrs"
                item-value="courseId"
                item-text="name"
                :items="course"
                :disabled="!editable"
                :label="$t('menu.course')"
              />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="2" class="py-0">
          <form-group :name="$t('form.status')" :validator="$v.status">
            <template slot-scope="{ attrs }">
              <v-select v-model="status" v-bind="attrs" :items="lockItems" :label="$t('form.status')" :disabled="!editable" />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="2" class="py-0">
          <form-group :name="$t('content.time_limit')" :validator="$v.timeLimit">
            <template slot-scope="{ attrs }">
              <v-text-field
                type="number"
                v-model="timeLimit"
                v-bind="attrs"
                :disabled="!editable"
                v-number
                min="0"
                :label="$t('content.time_limit')"
              />
            </template>
          </form-group>
        </v-col>
      </v-row>
    </v-card>

    <v-btn color="primary" v-if="!editable" @click="goToStas" :disabled="edited === true" class="btn-primary-custom mb-5">
      {{ $t('content.quiz_stastiktik') }}
    </v-btn>

    <!-- Questions -->
    <form-group :name="$t('form.question')" :validator="$v.quizQuestions">
      <template slot-scope="{ attrs }">
        <div class="red--text text-center">{{ attrs.errorMessages[0] }}</div>
        <QuestionItem v-for="question in quizQuestions" :key="question.id" :item="question" :editable="editable" ref="questions" />
      </template>
    </form-group>

    <!-- Question Trigger -->
    <v-btn v-if="editable" color="primary" class="btn-primary-custom mt-4" @click="addQuestion">{{ $t('add_questions') }}</v-btn>

    <div class="d-flex justify-end align-center">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
      <v-btn v-if="editable" color="primary" :loading="loading" class="btn-primary-custom" type="submit" @click="save">
        {{ $t(edit ? 'save' : 'submit') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import { mapGetters, mapMutations } from 'vuex';
import { mapFields, mapMultiRowFields } from 'vuex-map-fields';
import BaseTitle from '@/components/base/Title';
import QuestionItem from '@/components/QuestionItem';

export default {
  name: 'QuizCreator',
  components: {
    BaseTitle,
    QuestionItem
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    },
    isClass: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      course: 'QuizTeacher/courses',
      classLevel: 'QuizTeacher/classLevel',
      status: 'Reference/itemStatus',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    lockItems() {
      return [
        { text: this.$t('form.noactive'), value: false },
        { text: this.$t('form.active'), value: true }
      ];
    },
    ...mapFields('Question', ['quizTitle', 'timeLimit', 'gradeId', 'courseId', 'status']),
    ...mapMultiRowFields('Question', ['quizQuestions'])
  },
  validations: {
    quizTitle: { required },
    // timeLimit: { required, numeric },
    gradeId: { required },
    courseId: { required },
    status: { required },
    quizQuestions: { required, minLength: minLength(1) }
  },
  data: () => ({
    edit: false,
    loading: false,
    edited: '',
    dataClass: '',
    titleData: ''
  }),
  methods: {
    getDataGradeId() {
      this.loading = true;
      this.$store
        .dispatch('QuizTeacher/fetchListGradeId', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
        .then(res => {
          this.courseId = res.courseId;
          this.gradeId = res.gradeId;

          this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse', res.gradeId);
        })
        .finally(() => (this.loading = false));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    ...mapMutations('Question', ['addQuestion']),
    getClassLevel() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse');
    },
    getCourse() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse', this.gradeId);
    },
    getDetail() {
      const { id } = this.$route.params;
      this.$store.dispatch('QuizTeacher/fetchDetail', id).then(({ quizTitle, timeLimit, gradeId, courseId, status, quizQuestions, edited }) => {
        this.edited = edited;
        this.quizTitle = quizTitle;
        this.timeLimit = timeLimit;
        this.gradeId = gradeId;
        this.courseId = courseId;
        this.status = status;
        this.$store.commit(
          'Question/setQuestions',
          quizQuestions.map(item => {
            item.id = Math.random()
              .toString(36)
              .substr(2, 9);
            return item;
          })
        );
        this.getCourse();
      });
    },
    save() {
      if (this.$v.$invalid === true) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.field_filled') });
      }
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const { questions } = this.$refs;
      questions.forEach(qs => qs.$v.$touch());
      const success = questions.every(qs => qs.validate());
      if (!success) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.field_filled') });
      }
      if (!success) return;

      const { id } = this.$route.params;
      this.loading = true;
      this.$store
        .dispatch(`QuizTeacher/${id ? 'update' : 'save'}`, id)
        .then(() => {
          if (this.isClass) {
            this.$router.push({
              name:
                this.edit && !this.$route.params.classSectionId
                  ? 'QuizTeacherUpdateSuccessClass'
                  : !this.edit && !this.$route.params.classSectionId
                  ? 'QuizTeacherSuccessClass'
                  : this.edit && this.$route.params.classSectionId
                  ? 'QuizTeacherSectionUpdateSuccessClass'
                  : 'QuizTeacherSectionSuccessClass'
            });
          } else {
            this.$router.push({ name: this.edit ? 'QuizTeacherUpdateSuccess' : 'QuizTeacherSuccess' });
          }
        })
        .finally(() => (this.loading = false));
    },
    back() {
      if (this.isClass) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'QuizTeacherIndexClass' });
        } else {
          this.$router.push({ name: 'QuizTeacherSectionIndexClass' });
        }
      } else {
        this.$router.push({ name: 'QuizTeacherIndex' });
      }
    },
    goToStas() {
      if (this.isClass) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'TeacherQuizStatsClass' });
        } else {
          this.$router.push({ name: 'TeacherSectionQuizStatsClass' });
        }
      } else {
        this.$router.push({ name: 'TeacherQuizStats' });
      }
    }
  },
  created() {
    this.$store.commit('Question/CLEAR');
    if (this.$route.params.id) {
      this.edit = true;
      this.getDetail();
    }
    if (this.isClass) {
      this.getDataClass();
      this.getDataGradeId();
    } else {
      localStorage.removeItem('courseName');
    }
    this.getClassLevel();
  }
};
</script>

<style lang="scss" scoped>
.move-list {
  &-title {
    background: #00BF63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
